import { Preloader } from '@cian/components/lib';
import * as React from 'react';

import { IGeoDistrict } from '../../../api/geo';
import { ILocation } from '../../../api/locations';
import { CloseBtn } from '../../../common/components/close_button';
import { Modal } from '../../../common/components/modal';
import { ModalWrapper } from '../../../common/components/modal/wrapper';
import { IJsonQueryDistrict } from '../../../json_query';
import { SearchButtonContainer } from '../search_button/container';
import { MoscowDistrictsHeader } from './header/';
import { DistrictsLayout, isMoscowLocation } from './layout';
import { trackSaveDistrictsEvent } from './tracking';
const style = require('./index.css');

export interface IStateProps {
  isDataLoading: boolean;
  districts: IGeoDistrict[] | undefined;
  selectedLocation: ILocation | 'moscow_mo' | 'spb_lo';
  selectedDistricts: IJsonQueryDistrict[];
  includeNewMoscow: boolean | undefined;
}

export interface IDispatchProps {
  onClose(): void;
  onSave(): void;
  onSelected(id: number, name: string): void;
  onNewMoscowSwitched(includeNewMoscow: boolean | undefined): void;
  onRemoved(id: number): void;
  onSearchButtonClick(): void;
}

export type TDistrictsModalProps = IStateProps & IDispatchProps;

export class DistrictsModal extends React.Component<TDistrictsModalProps> {
  public render() {
    return (
      <ModalWrapper onClose={this.props.onClose}>
        <Modal
          minHeigth={200}
          minWidth={1000}
          width="85%"
          closeBtn={<CloseBtn onClick={this.props.onClose} isTransparent />}
          header={
            isMoscowLocation(this.props.selectedLocation) && (
              <MoscowDistrictsHeader
                includeNewMoscow={this.props.includeNewMoscow}
                onNewMoscowSwitched={this.props.onNewMoscowSwitched}
              />
            )
          }
          footer={
            <div className={style.footer}>
              <SearchButtonContainer onClick={this.handleClickOnSearchButton} />
            </div>
          }
        >
          <div>
            {this.props.isDataLoading && (
              <div className={style.preloaderWrapper}>
                <Preloader size={50} preloaderStyle={style.preloader} />
              </div>
            )}
            {this.props.districts && this.renderDistricts(this.props.districts)}
          </div>
        </Modal>
      </ModalWrapper>
    );
  }

  private renderDistricts(districts: IGeoDistrict[]) {
    return (
      <div className={style.districts}>
        <DistrictsLayout
          areas={districts}
          selectedLocation={this.props.selectedLocation}
          selectedDistricts={this.props.selectedDistricts}
          onSelected={this.props.onSelected}
          onRemoved={this.props.onRemoved}
        />
      </div>
    );
  }

  private handleClickOnSearchButton = () => {
    trackSaveDistrictsEvent(this.props.selectedDistricts.length);
    this.props.onSearchButtonClick();
  };
}
